import { createSelector } from '@reduxjs/toolkit';

import { isErrorType } from './utils';

import type { RootState } from 'react-redux';
import type { CommonErrorState } from './slice';
export const selectCommonError = (state: RootState) => state.commonError;

export const selectIsPopupError = createSelector(
  selectCommonError,
  (state: CommonErrorState) => !!(state.error && isErrorType(state.error, 'popup')),
);

export const selectIsRedirectError = createSelector(
  selectCommonError,
  (state: CommonErrorState) => !!(state.error && isErrorType(state.error, 'redirect')),
);

export const selectPopupErrorLabel = createSelector(
  selectCommonError,
  (state: CommonErrorState) => {
    if (state.error) {
      if (isErrorType(state.error, 'popup')) {
        return state.error.labelId;
      }
    }

    return null;
  },
);

export const selectInlineErrorLabel = createSelector(
  selectCommonError,
  (state: CommonErrorState) => {
    if (state.error && isErrorType(state.error, 'inline')) {
      return state.error.fields.map((field) => ({
        labelId: field.labelId,
        fieldName: field.fieldName,
      }));
    }

    return null;
  },
);
